import * as React from "react";
const B4Fill = (props) => (
  <svg
    width={26}
    height={26}
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19.6445 0.5H7.14453C3.69453 0.5 0.894531 3.28889 0.894531 6.72811V14.2069V15.4575C0.894531 18.8967 3.69453 21.6856 7.14453 21.6856H9.01953C9.35703 21.6856 9.80703 21.9107 10.0195 22.1858L11.8945 24.6746C12.7195 25.7751 14.0695 25.7751 14.8945 24.6746L16.7695 22.1858C17.007 21.8732 17.382 21.6856 17.7695 21.6856H19.6445C23.0945 21.6856 25.8945 18.8967 25.8945 15.4575V6.72811C25.8945 3.28889 23.0945 0.5 19.6445 0.5ZM8.39453 13.0063C7.69453 13.0063 7.14453 12.4435 7.14453 11.7556C7.14453 11.0678 7.70703 10.505 8.39453 10.505C9.08203 10.505 9.64453 11.0678 9.64453 11.7556C9.64453 12.4435 9.09453 13.0063 8.39453 13.0063ZM13.3945 13.0063C12.6945 13.0063 12.1445 12.4435 12.1445 11.7556C12.1445 11.0678 12.707 10.505 13.3945 10.505C14.082 10.505 14.6445 11.0678 14.6445 11.7556C14.6445 12.4435 14.0945 13.0063 13.3945 13.0063ZM18.3945 13.0063C17.6945 13.0063 17.1445 12.4435 17.1445 11.7556C17.1445 11.0678 17.707 10.505 18.3945 10.505C19.082 10.505 19.6445 11.0678 19.6445 11.7556C19.6445 12.4435 19.0945 13.0063 18.3945 13.0063Z"
      fill="#276AA6"
    />
  </svg>
);
export default B4Fill;
